<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 need-finance">
  <form [formGroup]="bookingFNIForm">
    <div class="pt-3 pb-3">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h3 class="sub-title text-uppercase mb-3">Personal Details</h3>
        </div>
        <div [ngClass]="{ 'col-12': bookingFNIForm.get('pan_type')?.value === 'Individual' }">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
            <label class="form-label mend">Account Type</label>
            <div class="d-flex gap-5 mt-1">
              <div *ngFor="let pan of panTypeOptions; let i = index " class="accountType" 
              [ngClass]="
              (bookingFNIForm.get('pan_type')?.value === 'Individual' && isAdhaarVerified && isPanVerified) || 
              (bookingFNIForm.get('pan_type')?.value !== 'Individual' && isPanVerified) 
                ? 'disabled' 
                : ''
            "
            
              >
              <!-- [ngClass]="this.userData?.account_type ? 'disabled' : ''" -->
                <!-- [attr.disabled]="typeOfBooking ? '' : null" -->
                <input 
                
               
                class="accountTypeInput"
                  type="radio"
                  name="pan_type"
                  [value]="pan.value"
                  (change)="updateFirstNameValidation(pan.value)"
                 
                  formControlName="pan_type"
                  [id]="'panType' + i"
                />
                <label class="ms-2" [for]="'panType' + i">{{ pan.label }}</label>
              </div>
            </div>
            <div class="error-message"
            *ngIf="(f['pan_type']?.touched || f['pan_type']?.dirty || submitted) && f['pan_type']?.errors">
            <div *ngIf="f['pan_type'].errors?.['required']"><b>Account Type is required</b></div>
          </div>
          </div>
          </div>
          <div
          class="col-12 col-sm-12 col-md-6 col-lg-12 col-xl-12 mb-4"
          *ngIf="bookingFNIForm.get('pan_type')?.value === 'Company'"
        >
        <div
        class="col-12 col-sm-12 col-md-6 col-lg-12 col-xl-12 mb-4"
        *ngIf="bookingFNIForm.get('pan_type')?.value === 'Company'"
      >
      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
        <label class="form-label mend">Company Name</label>
        <input
          formControlName="full_name"
          type="text"
          class="form-control h-48"
          placeholder="Ex. XYZ Pvt Ltd."
          (input)="validateCompanyName($event)"
          (blur)="checkCompanyNameError()"
          maxlength="50"
          [ngClass]="{'disabled':this.isPanVerified}"
         
        />
        <div *ngIf="companyNameError" class="error-message alert-danger">
          <b>Company Name cannot contain &lt;, &gt;, &#123;, &#125;, &#124;, &#126;, &#94;, &#42;</b> Please input correct details.
        </div>
        <div class="error-message" *ngIf="hasRequiredError('full_name')">
          <b> &nbsp; Company Name is Required</b>
        </div>
        <div
          class="error-message"
          *ngIf="hasError('full_name', 'invalidCompanyName')"
        >
          <b
            >Company Name cannot contain &lt; &gt; &#123; &#125; &#124; &#126;
            &#94; &#42;</b
          >
        </div>
      </div>
      </div>
        </div>
  
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4" *ngIf="bookingFNIForm.get('pan_type')?.value === 'Individual'">
            <label class="form-label mend">First Name</label>
            <input type="text"
            class="form-control h-48"
            [attr.disabled]="typeOfBooking ? '' : null" formControlName="first_name" placeholder="Ex. Pratik" name="first_name"
            maxlength="45"
  
             (keydown)="notAllowSpace($event)" 
             (input)="validateName($event, 'first_name')"
             (blur)="checkNameError('first_name')"
                   [ngClass]="{
                     'is-invalid': (f['first_name'].touched || f['first_name'].dirty || submitted) && f['first_name'].errors,
                     'disabled':this.isPanVerified && this.isAdhaarVerified 
                     
                   }" (input)="onInput($event)" />
                   <div *ngIf="nameErrors.first_name" class="error-message alert-danger">
                    <b>First Name cannot contain special characters (&period; &quot; &commat; &num; &dollar; and others)</b>
  
                  </div>
            <div class="error-message" *ngIf="(f['first_name'].touched || f['first_name'].dirty || submitted) && f['first_name'].errors">
              <div *ngIf="f['first_name'].errors?.['required']"><b>First name is required</b></div>
            </div>
            <div class="error-message" *ngIf="hasError('first_name', 'invalidIndividualName')">
              <b>First Name cannot contain special characters </b>
            </div>
              <div class="error-message" *ngIf="hasError('first_name', 'invalidCompanyName')">
              <b>First Name cannot contain &lt; &gt; &#123; &#125; &#124; &#126; &#94; &#42;</b>
            </div>
         </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4" *ngIf="bookingFNIForm.get('pan_type')?.value === 'Individual'">
            <label class="form-label ">Last Name</label>
            <input type="text" class="form-control h-48" [attr.disabled]="typeOfBooking ? '' : null" formControlName="last_name"  placeholder="Ex. Maurya"
              maxlength="45"
               (keydown)="notAllowSpace($event)" (input)="onInput($event)"
               (input)="validateName($event, 'last_name')"
               (blur)="checkNameError('last_name')"
               [ngClass]="{
                'disabled':this.isPanVerified && this.isAdhaarVerified
              }" 
               />
            <!-- <div class="error-message" *ngIf="hasRequiredError('last_name')">
                        <b> &nbsp; *Required</b>
                      </div> -->
            <!-- <div class="error-message" *ngIf="hasPatternError('last_name')">
              <b> &nbsp; *Invalid</b>
            </div> -->
            <div *ngIf="nameErrors.last_name" class="error-message alert-danger">
              <b>Last Name cannot contain special characters (&period; &quot; &commat; &num; &dollar; and others)</b>
  
            </div>
            <div class="error-message" *ngIf="hasError('last_name', 'invalidIndividualName')">
              <b>Last Name cannot contain special characters </b>
            </div>
              <div class="error-message" *ngIf="hasError('last_name', 'invalidCompanyName')">
              <b>Last Name cannot contain &lt; &gt; &#123; &#125; &#124; &#126; &#94; &#42;</b>
            </div>
          </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label mend">Email</label>
          <input type="text" class="form-control h-48" id="uEmail" placeholder="Ex. xyz@gmail.com"
            formControlName="email_id" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" (input)="onInput($event)"
            (keydown)="nAllowSpace($event)" maxlength="60" [ngClass]="{
              'disabled':(fniUserData?.PR_CONTACT_EMAIL_ADDR_s && typeOfBooking === 'FinanceJourneyNonOsp') || (fniOspGetlead?.email_id !== '' && typeOfBooking === 'FinanceJourney') ,
              'is-invalid': (f['email_id'].touched || f['email_id'].dirty || submitted) && f['email_id'].errors
            }"/>
            <div class="error-message" *ngIf="(f['pincode'].touched || f['pincode'].dirty || submitted) && f['pincode'].errors">
              <div *ngIf="f['email_id'].errors?.['required']"><b>Email is required</b></div>
              <div *ngIf="f['email_id'].errors?.['pattern']"><b>Invalid Email</b></div>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label mend">Pincode</label>
          <input type="text" class="form-control h-48" (keypress)="onlyNumberKey($event)" id="pincode" placeholder="Select your pincode" formControlName="pincode"
            [attr.disabled]="rowID" maxlength="6" (keyup)="addressByPincode()" [ngClass]="{
                              'is-invalid': (f['pincode'].touched || f['pincode'].dirty || submitted) && f['pincode'].errors
                            }" />
          <div class="error-message" *ngIf="(f['pincode'].touched || f['pincode'].dirty || submitted) && f['pincode'].errors">
            <div *ngIf="f['pincode'].errors?.['required']"><b>Pincode is required</b></div>
            <div *ngIf="f['pincode'].errors?.['pattern']"><b>Invalid Pincode</b></div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label mend ">State</label>
          <select class="form-select h-48" id="checkout-state" formControlName="state"
            [attr.disabled]="rowID  ? '' : null"  [ngClass]="{
              'is-invalid': (f['state'].touched || f['state'].dirty || submitted) && f['state'].errors
            }" >
            <option value="" selected disabled>Select your state</option>
            <option *ngFor="let state of stateList" value="{{ state?.code }}">
              {{ state?.name | titlecase }}
            </option>
          </select>
          <!-- <div class="error-message" *ngIf="hasRequiredError('state')">  <b>*Required</b></div> -->
          <div class="error-message"
          *ngIf="(f['state'].touched || f['state'].dirty || submitted) && f['state'].errors">
          <div *ngIf="f['state'].errors?.['required']"><b>State is required</b></div>
        </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label mend ">District</label>
          <select class="form-select  h-48" formControlName="district" id="checkout-district" formControlName="district"
            (change)="onChangeDistrict();" [attr.disabled]="rowID  ? '' : null"
            [ngClass]="{
              'is-invalid': (f['district'].touched || f['district'].dirty || submitted) && f['district'].errors
            }" >
            <option value="" selected disabled>Select your district</option>
            <option *ngFor="let district of districtList" value="{{ district }}">
              {{ district | titlecase }}
            </option>
          </select>
          <!-- <div class="error-message" *ngIf="hasRequiredError('district')">  <b>*Required</b></div> -->
          <div class="error-message"
          *ngIf="(f['district'].touched || f['district'].dirty || submitted) && f['district'].errors">
          <div *ngIf="f['district'].errors?.['required']"><b>District is required</b></div>
        </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label mend">Taluka</label>
          <select class="form-select  h-48" id="checkout-district" (change)="onTalukaSelect($event.target.value)"
            formControlName="taluka" [attr.disabled]="rowID"
            [ngClass]="{
              'is-invalid': (f['taluka'].touched || f['taluka'].dirty || submitted) && f['taluka'].errors
            }" >
            <option value="" selected disabled>Select your taluka</option>
            <option *ngFor="let taluka of talukaList" value="{{ taluka }}">
              {{ taluka | titlecase }}
            </option>
          </select>
          <!-- <div class="error-message" *ngIf="hasRequiredError('taluka')">  <b>*Required</b></div> -->
          <div class="error-message"
          *ngIf="(f['taluka'].touched || f['taluka'].dirty || submitted) && f['taluka'].errors">
          <div *ngIf="f['taluka'].errors?.['required']"><b>Taluka is required</b></div>
        </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label mend ">Locality</label>
          <select class="form-select  h-48" id="checkout-city" [attr.disabled]="rowID  ? '' : null"
            formControlName="city"
            [ngClass]="{
              'is-invalid': (f['city'].touched || f['city'].dirty || submitted) && f['city'].errors
            }" >
            <option value="" selected disabled>Select your locality</option>
            <option *ngFor="let city of cityList" value="{{ city }}">
              {{ city | titlecase }}
            </option>
          </select>
          <!-- <div class="error-message" *ngIf="hasRequiredError('city')">  <b>*Required</b></div> -->
          <div class="error-message"
          *ngIf="(f['city'].touched || f['city'].dirty || submitted) && f['city'].errors">
          <div *ngIf="f['city'].errors?.['required']"><b>Locality is required</b></div>
        </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label mend">Address 1</label>
          <input type="text" class="form-control h-48" formControlName="address1" placeholder="Address 1" maxlength="50"
            (keydown)="notAllowSpace($event)" (input)="onInput($event)"
            [ngClass]="{
              'is-invalid': (f['address1'].touched || f['address1'].dirty || submitted) && f['address1'].errors
            }" />
            <div class="error-message"
            *ngIf="(f['address1'].touched || f['address1'].dirty || submitted) && f['address1'].errors">
            <div *ngIf="f['address1'].errors?.['required']"><b>Address 1 is required</b></div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label mend">Address 2</label>
          <input type="text" (keydown)="preventTab($event)" class="form-control h-48" formControlName="address2" placeholder="Address 2"
             maxlength="60" (input)="onInput($event)"
            (keydown)="notAllowSpace($event)" [ngClass]="{
              'is-invalid': (f['address2'].touched || f['address2'].dirty || submitted) && f['address2'].errors
            }" />
            <div class="error-message"
            *ngIf="(f['address2'].touched || f['address2'].dirty || submitted) && f['address2'].errors">
            <div *ngIf="f['address2'].errors?.['required']"><b>Address 2 is required</b></div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h3 class="sub-title text-uppercase mb-3">E-KYC </h3>
        </div>
        <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label mend">Aadhaar Card</label>
          <input type="text" class="form-control h-48" formControlName="aadhar" [ngClass]="{
            'disabled': isAdhaarVerified && isAdhaarNoAvailable && isAdhaarNoAvailable !== ' ',
            'is-invalid': (f['aadhar'].touched || f['aadhar'].dirty || submitted) && submitted && f['aadhar'].errors
          }"
          placeholder="XXXX-XXXX-XXXX" maxlength="12" (keypress)="onlyNumberKey($event)"/>
          <div class="error-message"
              *ngIf="(f['aadhar'].touched || f['aadhar'].dirty || submitted) && f['aadhar'].errors">
              <div *ngIf="f['aadhar'].errors?.['required']"><b>Aadhar card is required</b></div>
              <div *ngIf="f['aadhar'].errors?.['pattern']"><b>Invalid Aadhaar Card No</b></div>
            </div>
          </div> -->
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4" *ngIf="bookingFNIForm.get('pan_type')?.value === 'Individual'">
            <label 
            class="form-label" 
            [ngClass]="{'mend': bookingFNIForm.get('pan_type')?.value === 'Individual'}">
            Aadhaar Card
          </label>
          <input type="text" class="form-control h-48" 
          [readonly]="(typeOfBooking !== 'FinanceJourneyNonOsp' && typeOfBooking !== 'FinanceJourney' && isAdhaarVerified && isAdhaarNoAvailable && isAdhaarNoAvailable !== ' ') || (fniOspGetlead?.lead_aadhar_number !='' && fniOspGetlead?.lead_aadhar_number != null && typeOfBooking == 'FinanceJourney')"
          [ngClass]="{
            'disabled': (typeOfBooking !== 'FinanceJourneyNonOsp' && typeOfBooking !== 'FinanceJourney' && isAdhaarVerified && isAdhaarNoAvailable && isAdhaarNoAvailable !== ' ') || (fniOspGetlead?.lead_aadhar_number !='' && fniOspGetlead?.lead_aadhar_number != null && typeOfBooking == 'FinanceJourney'),
            'is-invalid': (f['aadhar'].touched || f['aadhar'].dirty || submitted) && f['aadhar'].errors
          }"
          formControlName="aadhar" name="aadhar" placeholder="XXXX-XXXX-XXXX" maxlength="12" (keypress)="onlyNumberKey($event)"/>
          <div class="error-message"
              *ngIf="(f['aadhar'].touched || f['aadhar'].dirty || submitted) && f['aadhar'].errors">
              <div *ngIf="f['aadhar'].errors?.['required']"><b>Aadhar is required</b></div>
              <div *ngIf="f['aadhar'].errors?.['pattern']"><b>Invalid Aadhaar Card No</b></div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
            <label class="form-label mend">Pan Card Number</label>
            <input maxlength="10" #panInput formControlName="panNo" name="panNo" type="text" class="form-control h-48" (blur)="getPanValue($event)" (input)="getPanVal($event)" oninput="this.value = this.value.toUpperCase()"
            [readonly]="isPanVerified || (typeOfBooking === 'FinanceJourneyNonOsp' && fniUserData?.PR_CONTACT_PAN_s) || (typeOfBooking === 'FinanceJourney' && fniOspGetlead?.lead_pan_no)"
            [ngClass]="{
              'disabled':isPanVerified || (typeOfBooking === 'FinanceJourneyNonOsp' && fniUserData?.PR_CONTACT_PAN_s) || (typeOfBooking === 'FinanceJourney' && fniOspGetlead?.lead_pan_no) ,
              'is-invalid': (f['panNo'].touched || f['panNo'].dirty || submitted) && f['panNo'].errors
            }"
              formControlName="panNo" placeholder="PAN Number" (keydown)="notAllowSpace($event)" (input)="onInput($event)" />
              <div class="error-message" *ngIf="(f['panNo'].touched || f['panNo'].dirty || submitted) && f['panNo'].errors">
                <div *ngIf="f['panNo'].errors?.['required']"><b>Pan is required</b></div>
              </div>
              
              <!-- Display specific PAN errors -->
              <div class="error-message" *ngIf="bookingFNIForm.get('panNo')?.hasError('invalidPanForIndividual')">
                <b>*Invalid PAN No for Individual</b>
              </div>
              <div class="error-message" *ngIf="bookingFNIForm.get('panNo')?.hasError('invalidPanForCompany')">
                <b>*Invalid PAN No for Company</b>
              </div>
              
            <!-- <div class="error-message" *ngIf="checkPan">&nbsp; <b>*Vehicle booking with Online Finance is only enabled for Individual customers.</b></div> -->
          </div>
          
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4"
          *ngIf="isVasAvailable && (
            (bookingFNIForm.get('pan_type')?.value === 'Individual' && (!isAdhaarVerified || !isPanVerified)) || 
            (bookingFNIForm.get('pan_type')?.value !== 'Individual' && !isPanVerified)
          )">
            <button class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100 mt-4" data-toggle="tooltip"
              data-placement="top" title="Click here to Verify E-KYC" (click)="checkKYC()">Verify E-KYC</button>
          </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h3 class="sub-title text-uppercase mb-3">Additional Details</h3>
        </div>

        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label mend">Dealers near me</label>
          <select  (keydown)="preventTab($event)" class="form-select h-48" [attr.disabled]="rowID  ? '' : null" formControlName="division_id"
            (change)="setDivision()"
            [ngClass]="{
              'is-invalid': (f['division_id'].touched || f['division_id'].dirty || submitted) && f['division_id'].errors
            }" >
            <option disabled selected value="">Select a dealer</option>
            <option *ngFor="let div of divisions" [value]="div.division_id">
              {{ div.division_name }}
            </option>
          </select>
          <!-- <div class="error-message" *ngIf="hasRequiredError('division_id')">  <b>*Required</b></div> -->
          <div class="error-message"
          *ngIf="(f['division_id'].touched || f['division_id'].dirty || submitted) && f['division_id'].errors">
          <div *ngIf="f['division_id'].errors?.['required']"><b>Dealer is required</b></div>
        </div>
        </div>
        <div class="col-12 mb-4" *ngIf="!isDisabled">
          <h5 style="font-size: larger;">Please click <a href="" class="text-danger" data-bs-toggle="modal" data-bs-target="#exploredealer" (click)="getState()">here</a> to explore other dealers.</h5>
        </div>

        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4" *ngIf="isDisabled">
          <label class="form-label mend">Quantity</label>
          <input type="text" class="form-control  h-48" min="1" max="10" #myInput  (keypress)="NumberKeyEvent($event, myInput.value)"
            maxlength="2" autocomplete="new-password" numbersOnly
            formControlName="quantity" placeholder="Quantity" (keyup)="getQuantity()"
            (keydown)="notAllowSpace($event)"  [attr.disabled]="isDisabled ?  null : 'disabled'"
            [ngClass]="{
              'disabled':(typeOfBooking === 'FinanceJourneyNonOsp' && fniUserData?.QTY_s) ||(typeOfBooking === 'FinanceJourney' && fniOspGetlead?.quantity),
              'is-invalid': (f['quantity'].touched || f['quantity'].dirty || submitted) && f['quantity'].errors
            }"/>
            <!-- [attr.disabled]="rowID ? '' : null" -->
            <div class="error-message"
            *ngIf="(f['quantity'].touched || f['quantity'].dirty || submitted) && f['quantity'].errors">
            <div *ngIf="f['quantity'].errors?.['required']"><b>Quantity is required</b></div>
            <div class="error-message" *ngIf="bookingFNIForm.get('quantity').errors?.['min']">
              <b>   Min order qty is 1</b>
            </div>
            <div class="error-message" *ngIf="bookingFNIForm.get('quantity').errors?.['max']">
              <b>   Max order qty is 10</b>
            </div>
          </div>
        </div>

        <div *ngIf="dealerCode" class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-4">
          <label class="form-label">CRM ID : DSE/NSE/DDSO/DSM/NDRM/DSAdmin
          </label>
          <input type="text" (keyup)="checkDSE($event)" class="form-control  h-48" formControlName="dse"
            placeholder="To be filled by Dealership" (keydown)="notAllowSpace($event)" />
          <div class="red-hl" *ngIf="dseLoaded && !dseMatch">CRM ID : DSE/NSE/DDSO/DSM/NDRM/DSAdmin does not match</div>

        </div>
        <div class="row">
          <div class="col-12  mb-1 ">
            CAUTION:
            Here you may choose a Bank/ financier of your own choice out of the list below. By
            clicking on the specific link, you shall be re-directed to the dedicated web-page of the
            selected/ concerned Bank/ financier; and thereafter you shall be interacting and
            transacting with your Bank/ financier, without any recourse to Tata Motors Ltd.
        </div>
        </div>
        <div class="row">
          <div class="col-12  mb-1 d-flex">
          <input class="form-check-input mb-1 mt-2" style="border: 1px solid black;" type="checkbox" value="" #myCheckbox (change)="onCheckboxChange(myCheckbox.checked)" id="flexCheckDefault">
          <!-- <label class="form-check-label ms-3" for="flexCheckDefault">

          </label> -->
          <app-read-more>I agree,  I hereby, confirm to have read, understood and agreed with the following terms:<br>
            1. Tata Motors Ltd. has the agreements with its authorized dealers on a
            Principal to Principal basis, meaning thereby that Tata Motors Ltd. shall not
            be accountable for any act/ omission of its authorized dealer.<br>
            2. The transactions (including any transfer of funds, online as well as offline)
            with regard to booking and/ or purchase of the vehicle shall be exclusively
            between me and the selected dealer, without any recourse to Tata Motors
            Ltd.<br>
            3. Tata Motors Ltd. shall have no obligation towards me except for the
            warranty on the vehicle, if purchased by me, subject to the warranty terms
            conditions as per the warranty policy of Tata Motors Ltd.<br>
            4. Tata Motors Ltd. cannot be held responsible for your transactions with the
            Dealer merely for the reason of Website been provided by Tata Motors Ltd.</app-read-more>
        </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1 proceed-btn" [ngClass]="{'disabled': !checkBoxcheked}">
          <button class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100" [ngClass]="checkPan?'disabled':''" data-toggle="tooltip" data-placement="top"
           [attr.title]="typeOfBooking === 'FinanceJourney' || typeOfBooking === 'FinanceJourneyNonOsp' ? 'Click here for F&I Journey' : 'Click here for Confirm Booking'" (click)="showNextStep()" [disabled]="btndisablefn" >Proceed <span *ngIf="typeOfBooking === 'FinanceJourney' || typeOfBooking === 'FinanceJourneyNonOsp'">With F&I</span></button>
        </div>
        </div>
      </div>
    </div>
  </form>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.4)" size="medium" color="#fff" [fullScreen]="true">
  <span>
    <p style="color: white;margin-top: 250px;" *ngIf="fniOptyStatus">
      <b> Please wait, your request is being processed. This might take up to 2 mins.</b>
    </p>
    <p style="color: white; text-align: center;" *ngIf="fniOptyStatus">
      Status : {{fniOptyStatus}} </p>
  </span>
</ngx-spinner>
<button type="button" hidden id="popuperrorfnibook" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#popuperrorfni">
  Launch demo modal
</button>

<!-- Modal -->
<div class="modal fade" id="popuperrorfni" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="border: none;">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
     <p style="font-size: 16px;text-align: center;">{{errormessagefni}}</p>
      </div>
      <div class="modal-footer justify-content-center" style="border: none;">
        <button type="button" class="btn border-primary"  [routerLink]="'/account/booking'" data-bs-dismiss="modal">Go to profile</button>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="exploredealer" data-bs-backdrop="static" tabindex="-1" aria-labelledby="exploredealerLabel" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered modal-xl">
<div class="modal-content">
<div class="modal-header">
<h2 class="modal-title fs-4" id="exploredealerLabel">Dealer List (Commercial Vehicles)</h2>
<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
<div class="row dealerdiv">
<div class="col-4 col-lg-3 stateDiv">
<div class="list-group">
 <div *ngFor="let state of statesData;let i = index">
  <a  class="list-group-item list-group-item-action" [ngClass]="{' btn-grad-primary text-white': i === selectedState}" (click)="findDealersNewParticular(i,state)">{{state.name}}</a>
 </div>
</div>
</div>
<div class="col-8 col-lg-9 dealerDatadiv">
<div *ngIf="stateData && stateData?.length > 0; else noDataTemplate" style="overflow-x: visible;">
  <table class="table">
    <thead>
      <tr>
        <th>Dealer Name</th>
        <!-- <th>Mobile Number</th> -->
        <!-- <th>Locality</th> -->
        <th>State</th>
        <th>District</th>
        <th>Pincode</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let element of stateData">
        <td>{{ element.brand_name }}</td>
        <!-- <td>{{ element.mobile_number }}</td> -->
        <!-- <td>{{ element.locality }}</td> -->
        <td>{{ element.state_name }}</td>
        <td>{{ element.org_district }}</td>
        <td>{{ element.pincode }}</td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Template for no data -->
<ng-template #noDataTemplate>
  <div class="text-center p-3">
    <h3>No Data Found</h3>
  </div>
</ng-template>
</div>
</div>
</div>
<div class="modal-footer">
<button type="button" class="btn  btn-grad-primary text-white" data-bs-dismiss="modal">Close</button>
</div>
</div>
</div>
</div>
